<template>
  <template v-if="showPaths">
    <!-- Render all paths -->
    <EventmapPath
      v-for="path in eventmap.paths"
      :key="path.id"
      :path="path"
      :overridePathColor="overridePathColor"
      @pathClicked="handlePathClicked(path)"
      v-show="path.id !== selectedPath?.id"
    />
    <!-- Render the selected path -->
    <EventmapPath
      v-if="selectedPath"
      ref="selectedPathEl"
      :key="selectedPath.id"
      :path="selectedPath"
      overridePathColor="#000000"
    />
    <!-- Render path handles for editing -->
    <g v-if="lockSelected && selectedPath">
      <circle
        :cx="selectedPath.x1"
        :cy="selectedPath.y1"
        r="48"
        fill="#ffffff"
        stroke="#000000"
        stroke-width="5"
        ref="pathHandle1"
        class="cursor-move"
      />
      <circle
        :cx="selectedPath.x2"
        :cy="selectedPath.y2"
        r="48"
        fill="#ffffff"
        stroke="#000000"
        stroke-width="5"
        ref="pathHandle2"
        class="cursor-move"
      />
    </g>
  </template>
</template>

<script setup>
// Import necessary components
import { ref, defineExpose } from 'vue';
import EventmapPath from '~/Components/Common/Eventmap/EventmapPath.vue';

// Define props
const props = defineProps({
  eventmap: { type: Object, required: true },
  showPaths: Boolean,
  selectedPath: Object,
  lockSelected: Boolean,
  overridePathColor: String,
});

// Define emitted events
const emits = defineEmits(['pathClicked']);

// Handle path click event
function handlePathClicked(path) {
  if (!props.lockSelected && (!props.selectedPath || props.selectedPath.id !== path.id)) {
    emits('pathClicked', path);
  }
}

// Refs for selected path and handles
const selectedPathEl = ref(null);
const pathHandle1 = ref(null);
const pathHandle2 = ref(null);

// Expose refs to parent components
defineExpose({
  selectedPathEl,
  pathHandle1,
  pathHandle2,
});
</script>
